export default __webpack_public_path__ + "670d1f29e23209baa6b40f556935687d.png";